const DEFAULT_LOCAL_ORIGIN_DOMAIN = 'www.sortlist-test.com';

const isPointingToLocalBackend = () =>
  process.env.NEXT_PUBLIC_PUBLIC_API_BASE_URL_CLOUDFLARE?.includes('localhost') ?? false;

export const getPublicApiHost = (origin: string) => {
  if (origin.includes('localhost') && !isPointingToLocalBackend()) {
    return DEFAULT_LOCAL_ORIGIN_DOMAIN;
  }
  return origin.replace(/^https?:\/\//, '');
};
